(function() {
	'use strict';

	angular.module('adjustBenApp').controller('AdjustBenDialogInfoController',
			AdjustBenDialogInfoController);

	AdjustBenDialogInfoController.$inject = [ '$scope', '$uibModalInstance',
			'items', 'index', 'CommonService' ];

	function AdjustBenDialogInfoController($scope, $uibModalInstance, item,
			index, CommonService) {
		var adjustBenDialInfo = this;
		adjustBenDialInfo.customer = item.customer;
		adjustBenDialInfo.adjustBenId = item.adjustBenId;
		adjustBenDialInfo.benCode = item.benName;
		adjustBenDialInfo.benRatio = item.benRatio;
		adjustBenDialInfo.benRelation = item.benRelation;
		adjustBenDialInfo.index = index;
		adjustBenDialInfo.customer.birthDate = new Date(item.customer.birthDate);
		if(item.customer.idNumDate!=null||item.customer.idNumDate!=undefined){
			adjustBenDialInfo.customer.idNumDate = new Date(item.customer.idNumDate);
		}
		if (item.customer.locationCode != undefined) {
			adjustBenDialInfo.customer.provinceCode = item.customer.locationCode
					.substr(0, 2);
			adjustBenDialInfo.customer.districtCode = item.customer.locationCode
					.substr(0, 4);
			adjustBenDialInfo.customer.wardCode = item.customer.locationCode;
		}
		adjustBenDialInfo.cancel = cancel;
		adjustBenDialInfo.genderTypes = genderTypes;
		adjustBenDialInfo.marriedTypes = marriedTypes;
		adjustBenDialInfo.agreeEmailTypes = agreeEmailTypes;
		adjustBenDialInfo.agreeSmsTypes = agreeSmsTypes;
		adjustBenDialInfo.salutlTypes = salutlTypes;
		adjustBenDialInfo.lstNationality = CommonService.query({
			masterurl : 'nationality'
		});
		adjustBenDialInfo.lstProvince = CommonService.query({
			masterurl : 'province'
		});
		adjustBenDialInfo.lstDistrict = CommonService.query({
			masterurl : 'district',
			provinceCode : item.customer.provinceCode
		});
		adjustBenDialInfo.lstWard = CommonService.query({
			masterurl : 'ward',
			districtCode : item.customer.districtCode
		});
		adjustBenDialInfo.lstOcupation = CommonService.query({
			masterurl : 'occupation'
		});
		adjustBenDialInfo.lstPhoneCode = CommonService.query({
			masterurl : 'phone-code'
		});
		adjustBenDialInfo.getAllDistrictByProvince = function(cityCode) {
			if (cityCode != null || cityCode != undefined
					&& (num != null || num != undefined)) {
				adjustBenDialInfo.lstDistrict = CommonService.query({
					masterurl : 'district',
					provinceCode : cityCode
				});
			} else {
				adjustBenDialInfo.lstDistrict = null;
			}
		}
		// Get Wards
		adjustBenDialInfo.getAllWardByDistrict = function(districtCode) {
			if (districtCode != null || districtCode != undefined
					&& (districtCode != null || districtCode != undefined)) {
				adjustBenDialInfo.lstWard = CommonService.query({
					masterurl : 'ward',
					districtCode : districtCode
				});
			} else {
				adjustBenDialInfo.lstWard = null;
			}
		}

		function cancel() {
			$uibModalInstance.dismiss('cancel');
		}
		;
		adjustBenDialInfo.dob = new Date();
		adjustBenDialInfo.openDob = function() {
			adjustBenDialInfo.popupDob.opened = true;
		};
		adjustBenDialInfo.didNum = new Date();
		adjustBenDialInfo.openDidNum = function() {
			adjustBenDialInfo.popupDidNum.opened = true;
		};

		$scope.formats = [ 'dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd/MM/yyyy',
				'shortDate' ];
		$scope.format = $scope.formats[2];
		$scope.altInputFormats = [ 'M!/d!/yyyy' ];
		adjustBenDialInfo.popupDob = {
			opened : false
		};
		adjustBenDialInfo.popupDidNum = {
			opened : false
		};
	}
})();
